// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__Id5Bm","calendarButtons":"ClockData_calendarButtons__3C98z"};